module.exports = __webpack_public_path__ + "static/img/card-empty2.a3333aa1.png";